'use client';

import { useMemo, useEffect, useCallback } from 'react';

import { useSetState } from 'src/hooks/use-set-state';

import { AuthContext } from '../auth-context';
import { setSession, clearSession, isValidToken, getAccessToken, getUserDetails } from './utils';

// ----------------------------------------------------------------------

export function AuthProvider({ children }) {
  const { state, setState } = useSetState({
    user: null,
    loading: true,
  });

  const checkUserSession = useCallback(async () => {
    try {
      const accessToken = getAccessToken();
      const user_details = getUserDetails();
      // console.log('this is user_details from authProvider', user_details);
      // console.log('this is access_token from authProvider', accessToken);
      if (accessToken && isValidToken(accessToken)) {
        setSession(accessToken);

        // const res = await axios.get(endpoints.auth.me);

        // const { user } = res.data;

        // const user = { displayName: 'Uzair Ansari', email: 'uzair@gmail.com' };

        setState({ user: user_details, loading: false });
      } else {
        // Clear invalid session
        clearSession();
        setState({ user: null, loading: false });
      }
    } catch (error) {
      console.error('Error checking user session:', error);
      // Clear session on error
      clearSession();
      setState({ user: null, loading: false });
    }
  }, [setState]);

  useEffect(() => {
    checkUserSession();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // ----------------------------------------------------------------------

  const checkAuthenticated = state.user ? 'authenticated' : 'unauthenticated';

  const status = state.loading ? 'loading' : checkAuthenticated;

  const memoizedValue = useMemo(
    () => ({
      user: state.user
        ? {
            ...state.user,
            role: state.user?.role ?? 'admin',
          }
        : null,
      checkUserSession,
      loading: status === 'loading',
      authenticated: status === 'authenticated',
      unauthenticated: status === 'unauthenticated',
    }),
    [checkUserSession, state.user, status]
  );

  return <AuthContext.Provider value={memoizedValue}>{children}</AuthContext.Provider>;
}
